/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { AdAlertListCardVehicleFragmentDoc } from '../../../../ad-alert-cards/src/lib/AdAlertListCard/AdAlertListCard.hook'
import { AdOnBoardPassengersVehicleFragmentDoc } from '../../../../ad-passenger-list/src/lib/AdOnBoardPassengers/AdOnBoardPassengers.hook'
import { AdWaypointPassengersWaypointFragmentDoc } from '../../../../ad-passenger-list/src/lib/AdWaypointPassengers/AdWaypointPassengers.hook'
import { BookabilityCardVehicleFragmentDoc } from '../../../../ad-telematics-cards/src/lib/BookabilityCard/BookabilityCard.hook'
import { SystemComponentsCardVehicleFragmentDoc } from '../../../../ad-telematics-cards/src/lib/SystemComponentsCard/SystemComponentsCard.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { VehicleMissionCardHeaderFragmentDoc } from '../../../../vehicle-mission/src/lib/VehicleMissionCard/VehicleMissionCardHeader/vehicleMissionCardHeader.hook'
import {
  VehicleMissionDeliveryActionFragmentDoc,
  VehicleMissionHubReturnActionFragmentDoc,
  VehicleMissionPickupActionFragmentDoc,
  VehicleMissionReallocationActionFragmentDoc,
} from '../../../../vehicle-mission/src/lib/VehicleMissionCard/vehicleMissionCard.hook'
import { AdVehicleStreamAdVehicleDoorStatusFragmentDoc } from '../AdVehicleDoorStatus/AdVehicleDoorStatus.hook'
import {
  AdVehicleStreamAlertVehicleMapVehicleFragmentDoc,
  AdVehicleStreamAlertVehicleMapWaypointFragmentDoc,
} from '../AlertVehicleMap/AlertVehicleMap.hook'
import { AdVehicleStreamEvaluateCabinSafetyCheckStatusFragmentDoc } from '../evaluateCabinSafetyCheckStatus/evaluateCabinSafetyCheckStatus.hook'
import { AdVehicleStreamHubReturnVehicleFragmentDoc } from '../HubReturn/graphql/HubReturnVehicle.hook'
import { AdVehicleStreamServiceCancellationVehicleFragmentDoc } from '../ManageService/ManageService.hook'
import { AdVehicleStreamPassengerUnbuckledActionCardVehicleFragmentDoc } from './ActionCards/PassengerUnbuckledActionCard/PassengerUnbuckledActionCard.hook'
import { AdVehicleStreamVehicleGuidanceActionCardVehicleFragmentDoc } from './ActionCards/VehicleGuidanceActionCard/VehicleGuidanceActionCard.hook'
import { AdVehicleStreamHeaderVehicleFragmentDoc } from './AdVehicleStreamHeader/AdVehicleStreamHeader.hook'

const defaultOptions = {} as const
export type AdVehicleStreamQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamQuery = {
  __typename?: 'Query'
  vehicleByID: {
    __typename?: 'Vehicle'
    id: string
    isSelfDriving: boolean
    label: number | null
    inService: boolean | null
    notInServiceReasons: Array<Types.NotInServiceReason> | null
    isResponsive: boolean | null
    totalChildrenInVehicle: number | null
    totalPassengersInVehicle: number | null
    totalPassengersToPickUp: number | null
    totalWheelchairUsersInVehicle: number | null
    latestADTelemetry: {
      __typename?: 'ADTelemetry'
      speed: {
        __typename?: 'ADTelemetryFloatWithTimestamp'
        value: number
      } | null
      rightSlidingDoorOpen: {
        __typename?: 'ADTelemetryBooleanWithTimestamp'
        value: boolean
        timestamp: string
      } | null
      sdsMode: {
        __typename?: 'SDSModeWithTimestamp'
        sdsMode: Types.SdsMode
      } | null
      missionConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      signalConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      cabinConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
    } | null
    pooling: {
      __typename?: 'Pooling'
      reason: Types.PoolingReason | null
      enabled: boolean
      enabledUpdatedAt: string | null
    } | null
    currentlyLocatedInServiceBreakLocation: {
      __typename?: 'ServiceBreakLocation'
      id: string
    } | null
    fccOperatorAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{
        __typename: 'FccAdAlert'
        id: string
        status: Types.FccAdAlertStatus
        type: Types.FccAdAlertType
      }>
    } | null
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      adStateUpdatedAt: string | null
      routeProvider: Types.FccRouteProvider | null
      cabinSafetyCheckStatus: Types.FccCabinSafetyCheckStatus | null
      adState: Types.FccWaypointState | null
      id: string
      fccStop: {
        __typename?: 'FccStop'
        id: string | null
        names: Partial<Record<'de' | 'en' | 'no', string>>
      } | null
      stop: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
        routingLocation: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        }
      } | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            deliveryStatus: Types.FccWaypointDeliveryActionStatus
            trip: { __typename?: 'Trip'; id: string } | null
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | {
            __typename: 'FccWaypointHubReturnAction'
            id: string
            estimatedAt: string
            isPlannedHubReturn: boolean
            reason: Types.FccWaypointHubReturnReason
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            area: {
              __typename?: 'Area'
              id: string
              name: string | null
              type: Types.AreaType
              details:
                | { __typename?: 'CooperationDetails' }
                | { __typename?: 'HubDetails'; displayName: string }
                | { __typename?: 'InFieldBreakDetails' }
                | { __typename?: 'ShortBreakDetails' }
                | null
              serviceArea: { __typename?: 'ServiceArea'; id: string }
            } | null
          }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            estimatedAt: string
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            pickedUpAt: string | null
            pickupStatus: Types.FccWaypointPickupActionStatus
            trip: { __typename?: 'Trip'; id: string } | null
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | {
            __typename: 'FccWaypointReallocationAction'
            estimatedAt: string
            id: string
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          }
      >
      stopWithServiceArea: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
    }> | null
    latestLocation: {
      __typename?: 'VehicleLocation'
      heading: number | null
      timestamp: string | null
      location: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      } | null
    } | null
    fccCurrentAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{
        __typename: 'FccAdAlert'
        id: string
        type: Types.FccAdAlertType
        status: Types.FccAdAlertStatus
        createdAt: string
      }>
    } | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    region: { __typename?: 'Region'; id: string } | null
    fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
    fccHandledByOperatorDetails: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    adSeatsLayout: {
      __typename?: 'FccSeatLayout'
      thirdRowRight: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
      thirdRowMiddle: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
      thirdRowLeft: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
      secondRowRight: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
      secondRowMiddle: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
      secondRowLeft: {
        __typename?: 'FccSeat'
        occupancy: Types.FccSeatOccupancy
        seatbelt: Types.FccSeatbelt
      }
    } | null
  }
}

export type AdVehicleStreamStopHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamStopHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStopHandlingVehicle: any | null
}

export type AdVehicleStreamVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
  label: number | null
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  isResponsive: boolean | null
  totalChildrenInVehicle: number | null
  totalPassengersInVehicle: number | null
  totalPassengersToPickUp: number | null
  totalWheelchairUsersInVehicle: number | null
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    speed: {
      __typename?: 'ADTelemetryFloatWithTimestamp'
      value: number
    } | null
    rightSlidingDoorOpen: {
      __typename?: 'ADTelemetryBooleanWithTimestamp'
      value: boolean
      timestamp: string
    } | null
    sdsMode: {
      __typename?: 'SDSModeWithTimestamp'
      sdsMode: Types.SdsMode
    } | null
    missionConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
    signalConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
    cabinConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
  } | null
  pooling: {
    __typename?: 'Pooling'
    reason: Types.PoolingReason | null
    enabled: boolean
    enabledUpdatedAt: string | null
  } | null
  currentlyLocatedInServiceBreakLocation: {
    __typename?: 'ServiceBreakLocation'
    id: string
  } | null
  fccOperatorAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      status: Types.FccAdAlertStatus
      type: Types.FccAdAlertType
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adStateUpdatedAt: string | null
    routeProvider: Types.FccRouteProvider | null
    cabinSafetyCheckStatus: Types.FccCabinSafetyCheckStatus | null
    adState: Types.FccWaypointState | null
    id: string
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stop: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
      routingLocation: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          deliveryStatus: Types.FccWaypointDeliveryActionStatus
          trip: { __typename?: 'Trip'; id: string } | null
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          id: string
          estimatedAt: string
          isPlannedHubReturn: boolean
          reason: Types.FccWaypointHubReturnReason
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          area: {
            __typename?: 'Area'
            id: string
            name: string | null
            type: Types.AreaType
            details:
              | { __typename?: 'CooperationDetails' }
              | { __typename?: 'HubDetails'; displayName: string }
              | { __typename?: 'InFieldBreakDetails' }
              | { __typename?: 'ShortBreakDetails' }
              | null
            serviceArea: { __typename?: 'ServiceArea'; id: string }
          } | null
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          pickedUpAt: string | null
          pickupStatus: Types.FccWaypointPickupActionStatus
          trip: { __typename?: 'Trip'; id: string } | null
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | {
          __typename: 'FccWaypointReallocationAction'
          estimatedAt: string
          id: string
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
        }
    >
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
  }> | null
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    timestamp: string | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      createdAt: string
    }>
  } | null
  fleet: { __typename?: 'Fleet'; id: string } | null
  region: { __typename?: 'Region'; id: string } | null
  fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
  fccHandledByOperatorDetails: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  adSeatsLayout: {
    __typename?: 'FccSeatLayout'
    thirdRowRight: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    thirdRowMiddle: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    thirdRowLeft: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowRight: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowMiddle: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowLeft: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
  } | null
}

export const AdVehicleStreamVehicleFragmentDoc = gql`
    fragment AdVehicleStreamVehicle on Vehicle {
  id
  latestADTelemetry {
    speed {
      value
    }
  }
  pooling {
    reason
  }
  currentlyLocatedInServiceBreakLocation {
    id
  }
  fccOperatorAdAlerts {
    alerts {
      id
      status
    }
  }
  fccUpcomingWaypoints {
    ...AdVehicleStreamAlertVehicleMapWaypoint
    ...AdWaypointPassengersWaypoint
    ...AdVehicleStreamEvaluateCabinSafetyCheckStatus
    adStateUpdatedAt
    fccStop {
      id
      names
    }
    stop {
      id
      serviceArea {
        id
      }
    }
    routeProvider
    cabinSafetyCheckStatus
    actions {
      __typename
      ... on FccWaypointPickupAction {
        ...vehicleMissionPickupAction
      }
      ... on FccWaypointDeliveryAction {
        ...vehicleMissionDeliveryAction
      }
      ... on FccWaypointHubReturnAction {
        ...vehicleMissionHubReturnAction
      }
      ... on FccWaypointReallocationAction {
        ...vehicleMissionReallocationAction
      }
    }
  }
  ...AdVehicleStreamHeaderVehicle
  ...AdVehicleStreamVehicleGuidanceActionCardVehicle
  ...AdVehicleStreamAlertVehicleMapVehicle
  ...AdVehicleStreamAdVehicleDoorStatus
  ...AdVehicleStreamServiceCancellationVehicle
  ...AdVehicleStreamHubReturnVehicle
  ...AdVehicleStreamPassengerUnbuckledActionCardVehicle
  ...AdOnBoardPassengersVehicle
  ...VehicleMissionCardHeader
  ...BookabilityCardVehicle
  ...SystemComponentsCardVehicle
  ...AdAlertListCardVehicle
}
    ${AdVehicleStreamAlertVehicleMapWaypointFragmentDoc}
${AdWaypointPassengersWaypointFragmentDoc}
${AdVehicleStreamEvaluateCabinSafetyCheckStatusFragmentDoc}
${VehicleMissionPickupActionFragmentDoc}
${VehicleMissionDeliveryActionFragmentDoc}
${VehicleMissionHubReturnActionFragmentDoc}
${VehicleMissionReallocationActionFragmentDoc}
${AdVehicleStreamHeaderVehicleFragmentDoc}
${AdVehicleStreamVehicleGuidanceActionCardVehicleFragmentDoc}
${AdVehicleStreamAlertVehicleMapVehicleFragmentDoc}
${AdVehicleStreamAdVehicleDoorStatusFragmentDoc}
${AdVehicleStreamServiceCancellationVehicleFragmentDoc}
${AdVehicleStreamHubReturnVehicleFragmentDoc}
${AdVehicleStreamPassengerUnbuckledActionCardVehicleFragmentDoc}
${AdOnBoardPassengersVehicleFragmentDoc}
${VehicleMissionCardHeaderFragmentDoc}
${BookabilityCardVehicleFragmentDoc}
${SystemComponentsCardVehicleFragmentDoc}
${AdAlertListCardVehicleFragmentDoc}`
export const AdVehicleStreamDocument = gql`
    query AdVehicleStream($vehicleId: ID!) {
  vehicleByID(id: $vehicleId) {
    ...AdVehicleStreamVehicle
  }
}
    ${AdVehicleStreamVehicleFragmentDoc}`

/**
 * __useAdVehicleStreamQuery__
 *
 * To run a query within a React component, call `useAdVehicleStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleStreamQuery,
    AdVehicleStreamQueryVariables
  > &
    (
      | { variables: AdVehicleStreamQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AdVehicleStreamQuery, AdVehicleStreamQueryVariables>(
    AdVehicleStreamDocument,
    options,
  )
}
export function useAdVehicleStreamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleStreamQuery,
    AdVehicleStreamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleStreamQuery,
    AdVehicleStreamQueryVariables
  >(AdVehicleStreamDocument, options)
}
// @ts-ignore
export function useAdVehicleStreamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleStreamQuery,
    AdVehicleStreamQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamQuery,
  AdVehicleStreamQueryVariables
>
export function useAdVehicleStreamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamQuery,
        AdVehicleStreamQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamQuery | undefined,
  AdVehicleStreamQueryVariables
>
export function useAdVehicleStreamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamQuery,
        AdVehicleStreamQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleStreamQuery,
    AdVehicleStreamQueryVariables
  >(AdVehicleStreamDocument, options)
}
export type AdVehicleStreamQueryHookResult = ReturnType<
  typeof useAdVehicleStreamQuery
>
export type AdVehicleStreamLazyQueryHookResult = ReturnType<
  typeof useAdVehicleStreamLazyQuery
>
export type AdVehicleStreamSuspenseQueryHookResult = ReturnType<
  typeof useAdVehicleStreamSuspenseQuery
>
export type AdVehicleStreamQueryResult = Apollo.QueryResult<
  AdVehicleStreamQuery,
  AdVehicleStreamQueryVariables
>
export const AdVehicleStreamStopHandlingVehicleDocument = gql`
    mutation AdVehicleStreamStopHandlingVehicle($vehicleId: ID!) {
  fccStopHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type AdVehicleStreamStopHandlingVehicleMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamStopHandlingVehicleMutation,
    AdVehicleStreamStopHandlingVehicleMutationVariables
  >

/**
 * __useAdVehicleStreamStopHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamStopHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamStopHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamStopHandlingVehicleMutation, { data, loading, error }] = useAdVehicleStreamStopHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamStopHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamStopHandlingVehicleMutation,
    AdVehicleStreamStopHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamStopHandlingVehicleMutation,
    AdVehicleStreamStopHandlingVehicleMutationVariables
  >(AdVehicleStreamStopHandlingVehicleDocument, options)
}
export type AdVehicleStreamStopHandlingVehicleMutationHookResult = ReturnType<
  typeof useAdVehicleStreamStopHandlingVehicleMutation
>
export type AdVehicleStreamStopHandlingVehicleMutationResult =
  Apollo.MutationResult<AdVehicleStreamStopHandlingVehicleMutation>
export type AdVehicleStreamStopHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamStopHandlingVehicleMutation,
    AdVehicleStreamStopHandlingVehicleMutationVariables
  >
